module.exports = __webpack_public_path__ + "img/credit-qr-1.89550657.png";